<template>
  <div class="achievements">
    <h1 class="heading1">
      {{ $t('Мои достижения') }}
    </h1>

    <Swiper class="achievements_wrap" :options="swiperOption">
      <Achievement :total-sum="currenciesSum">
        {{ $t('Возврат золота') }}
      </Achievement>

      <Achievement :total-sum="shopBonusSum">
        {{ $t('Золота за покупки в Премиум магазине') }}
        <p slot="tooltip-text">
          {{ $t('Расплачивайся методом «Карта Леста» в Премиум-магазине и получай +5% в золоте от суммы покупки') }}
        </p>
      </Achievement>

      <Achievement :total-sum="bonusSum">
        {{ $t('Дополнительные бонусы') }}
        <p slot="tooltip-text">
          {{ bonusTooltipTextByCountry }}
        </p>
      </Achievement>
    </Swiper>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import { swiper as Swiper } from 'vue-awesome-swiper'

import Achievement from './AchievementItem.vue'

const cards = namespace('cards')

@Component({
  components: { Swiper, Achievement }
})
class Achievements extends Vue {
  @cards.Action fetchCardsBonuses
  @cards.Getter accrualsBonusSumsAllCards
  @cards.Getter accrualsCurrenciesSumsAllCards
  @cards.Getter accrualsPremiumShopBonusAllCards
  // @cards.Getter accrualsBonusSumsByGames
  // @cards.Getter accrualsCurrenciesSumsByGames
  @State('country') currentCountry

  showTooltip = false

  swiperOption = {
    slidesPerView: 'auto',
    watchOverflow: true
  }

  created () {
    this.fetchCardsBonuses()
  }

  get bonusTooltipTextByCountry () {
    return this.$t({
      'RU': 'Получай дополнительные бонусы с картой каждый месяц',
      'BY': 'Получай дополнительные бонусы с картой каждый месяц'
    }[this.currentCountry])
  }

  get bonusSum () {
    return this.calculateAccrualSum(this.accrualsBonusSumsAllCards)
  }

  get currenciesSum () {
    return this.calculateAccrualSum(this.accrualsCurrenciesSumsAllCards)
  }

  get shopBonusSum () {
    return this.calculateAccrualSum(this.accrualsPremiumShopBonusAllCards)
  }

  calculateAccrualSum (items) {
    return items.reduce((sum, { accrualAmount }) => sum + accrualAmount, 0)
  }

  /**
   * calculated in game bonuses (like boosters) sums grouped by games
   * Until better times
   get bonusSumByGames () {
    const result = {}
    Object.keys(this.accrualsBonusSumsByGames).forEach(key => {
      result[key] = this.accrualsBonusSumsByGames[key].reduce((sum, accrual) => sum + accrual.value, 0)
    })

    return result
  }
   */

  /**
   * calculated sums in game currencies (like gold) grouped by games
   * Until better times
   get currenciesSumByGames () {
    const result = {}
    Object.keys(this.accrualsCurrenciesSumsByGames).forEach(key => {
      result[key] = this.accrualsCurrenciesSumsByGames[key].reduce((sum, accrual) => sum + accrual.value, 0)
    })

    return result
  }
   */
}

export default Achievements
</script>

<style lang="scss">
.achievements {
  padding: 22px 9.375% 0;
  @include media_tablet {
    padding: 29px 7.8% 0;
  }
  @include media_desktop {
    margin: 0 auto;
    max-width: $content_max-width;
    padding: 34px 3.66% 0;
  }

  &_wrap {
    display: flex;
    margin-top: 15px;
    overflow: visible;
    @include media_tablet {
      margin-top: 14px;
    }
    @include media_desktop {
      margin-top: 29px;
    }
  }
  &_item {
    background: #202020;
    border-radius: 4px;
    box-sizing: border-box;
    color: #fff;
    display: inline-flex;
    align-items: center;
    height: 44px;
    width: 90%;
    position: relative;
    margin-right: 12%;
    padding: 0 14px;
    @include media_tablet {
      border-radius: 9px;
      height: 60px;
      width: 30%;
      margin-right: 5%;
      padding: 0 38px 0 9px;
    }
    @include media_desktop {
      border-radius: 8px;
      height: 88px;
      padding: 0 78px 0 32px;
      transition: background-color $duration;

      &:hover {
        background: #2d2d2d;
      }
    }
  }
  &_sum {
    font-size: 17px;
    margin-right: 20px;
    padding-right: 20px;
    position: relative;
    white-space: nowrap;
    @include media_tablet {
      font-size: 18px;
      margin-right: 10px;
      padding-right: 10px;
    }
    @include media_desktop {
      font-size: 34px;
      margin-right: 30px;
      padding-right: 30px;
    }

    &:after {
      border-left: 1px solid rgba(255, 255, 255, 0.1);
      content: '';
      height: 24px;
      right: 0;
      top: 0;
      position: absolute;
      @include media_tablet {
        height: 40px;
        top: -8px;
      }
      @include media_desktop {
        height: 48px;
        top: 0;
      }
    }
  }
  &_description {
    color: $font-color;
    font-size: 10px;
    line-height: 10px;
    @include media_tablet {
      font-size: 12px;
      line-height: 14px;
    }
    @include media_desktop {
      font-size: 16px;
      line-height: 20px;
    }
  }
  &_info {
    display: none;
    border-radius: 50%;
    border: 1px solid;
    color: #fff;
    cursor: pointer;
    font-size: 10px;
    line-height: 15px;
    height: 16px;
    width: 16px;
    position: absolute;
    top: 13px;
    right: 15px;
    text-align: center;
    @include media_tablet {
      display: block;
      top: 21px;
      right: 10px;
    }
    @include media_desktop {
      top: 35px;
      right: 30px;
      transition: background-color $duration,
                  border-color $duration,
                  color $duration;

      .achievements_item:hover & {
        background-color: #fff;
        border-color: #fff;
        color: #181919;
      }
    }
  }
  &_tooltip {
    background: #fff;
    border-radius: 4px;
    color: #1a1b1c;
    font-size: 10px;
    line-height: 10px;
    margin-bottom: 13px;
    padding: 10px 19px;
    position: absolute;
    right: 0;
    bottom: 100%;

    &:after {
      content: "";
      border: {
        style: solid;
        width: 7px;
        color: #fff transparent transparent;
      }
      position: absolute;
      top: 100%;
      right: 19px;
      @include media_tablet {
        right: 13px;
      }
      @include media_desktop {
        right: 31px;
      }
    }
    @include media_tablet {
      border-radius: 9px;
      font-size: 12px;
      line-height: 12px;
    }
    @include media_desktop {
      border-radius: 8px;
      font-size: 14px;
      line-height: 14px;
    }
  }
  &_tooltip-animate {
    @include fade-in-out;
  }
}
</style>
